import { Sparkles } from "lucide-react";
import Layout from "@/components/Layout";
import { PageHeader } from "@/components/PageHeader";
import { useWorkspaceAnalytics } from "@/hooks/use-workspace-analytics";
import { WorkspaceSkeleton } from "@/components/workspace/WorkspaceSkeleton";
import { MetricsCards } from "@/components/workspace/MetricsCards";
import { ClaimsStatusChart } from "@/components/workspace/ClaimsStatusChart";
import { UpcomingTasks } from "@/components/workspace/UpcomingTasks";
import { RecentActivities } from "@/components/workspace/RecentActivities";

export default function Workspace() {
    const { analytics, isLoading } = useWorkspaceAnalytics();

    if (isLoading || !analytics) {
        return <WorkspaceSkeleton />;
    }

    return (
        <Layout>
            <div className="md:px-4 md:py-8">
                {/* Header */}
                <PageHeader
                    title="My Workspace"
                    description={
                        <>
                            Your personal analytics dashboard and activity overview
                            <Sparkles className="h-4 w-4 text-primary" />
                        </>
                    }
                />

                {/* Metrics Cards */}
                <MetricsCards analytics={analytics} />

                {/* Main Content Grid */}
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                    <ClaimsStatusChart claimsByStatus={analytics.claimsByStatus} />
                    <UpcomingTasks tasks={analytics.upcomingTasks} />
                    <RecentActivities activities={analytics.recentActivities} />
                </div>
            </div>
        </Layout>
    );
}
